/**
 * Builds a sliding window of page numbers around the current page.
 * Returns up to `count + 1 + count` pages centered on the current page.
 * The window is clamped to [1, total], so near the edges it slides instead
 * of going out of bounds.
 *
 * Examples (total = 20, count = 3):
 *   current=1   -> [1, 2, 3, 4, 5, 6, 7]
 *   current=10  -> [7, 8, 9, 10, 11, 12, 13]
 *   current=20  -> [14, 15, 16, 17, 18, 19, 20]
 */
export function getPageRange(
  current: number,
  total: number,
  count = 3,
): number[] {
  if (total <= 0) return [];

  const windowSize = count + 1 + count;

  if (total <= windowSize) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  let start = current - count;
  let end = current + count;

  if (start < 1) {
    end += 1 - start;
    start = 1;
  }
  if (end > total) {
    start -= end - total;
    end = total;
  }

  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
}
